/* jshint esversion: 6 */
/* jshint ignore:start */

import React, { useContext, useEffect, useState } from 'react';
import wallet from "../Icon/wallet.svg";
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import Razorpay from './Razorpay';
import Paypal from './PayPal';
import PayStack from './PayStack';
import FlutterWave from './FlutterWave';
import SenangPay from './SenangPay';
import Payfast from './Payfast';
import Midtrans from './Midtrans';
import Checkout from './Checkout';
import KhaltiPayment from './Khalti_Payment';
import MercadoPagoCheckout from './MercadoPago';
import PaytmPayment from './PaytmPayment';
import Cashfree from './Cashfree';
import SSLCommerz from './SSLCommerz';
import Instamojo from './Instamojo';
import Tap from './Tap';
import PerfectMoney from './PerfectMoney';
import PayDunya from './PayDunya';
import Mollie from './Mollie';
import BKash from './bKash';
import { showTost } from "../showTost";
import { StripePayment } from './Stripe';
import { useTranslation } from 'react-i18next';

const Payment = ({ Amount, ItemType, ItemId }) => {
    const { t } = useTranslation();

    const { basUrl, imageBaseURL, setToggleButton, setAmount, payClose, page, buyCoin, setWalletCoin, setBuyCoin, button, setButton } = useContext(MyContext);

    const [input, setInput] = useState();
    const [border, setBorder] = useState();
    const [payDetails, setPayDetails] = useState([]);
    const [payId, setPayId] = useState();
    const [btnDis, setBtnDis] = useState(false);
    const [amount, setamount] = useState();
    const [coin, setCoin] = useState();
    const [attributes, setAttributes] = useState();

    const PurchaseHandler = (id) => {
        if (input || Amount) {
            if (btnDis) {
                setWalletCoin(Amount);
                setamount(Amount - coin);
            } else {
                setAmount(input);
                if (Amount) {
                    setamount(Amount);
                } else {
                    setamount(input);
                    localStorage.setItem("Amount", input);
                }
            }

            if (!btnDis) {
                if (border) {
                    setPayId(id);
                    setButton(true);
                } else {
                    showTost({ title: "Please Select Payment Method" });
                }
            } else {
                if (Amount > coin) {
                    showTost({ title: "Please Add Balance..!!" });
                    setToggleButton(false);
                } else {
                    setBuyCoin("PaymentDone");
                }
            }
        } else {
            showTost({ title: "Please Enter Amount" });
        }
    };

    useEffect(() => {
        axios.post(`${basUrl}payment_gateway`)
            .then((res) => {
                setPayDetails(res.data.paymentdata || []);
            });

        const localData = localStorage.getItem("Register_User");

        if (localData) {
            const userData = JSON.parse(localData);

            axios.post(`${basUrl}wallet_report`, { uid: userData.id })
                .then((res) => {
                    if (res.data.Result === "true") {
                        setCoin(res.data.wallet);
                    }
                });
        }
    }, [basUrl]);

    useEffect(() => {
        if (payClose || buyCoin) {
            setInput("");
            setBorder("");
            setAmount("");
            setPayId("");
            setButton(false);
        }
    }, [payClose, buyCoin, setAmount, setButton]);

    const SwitchHandler = () => {
        if (btnDis) {
            setBtnDis(false);
        } else {
            setBtnDis(true);
        }
        setBorder("");
    };

    const SelectPaymentMethodHandle = (itemTitle) => {
        setBtnDis(false);
        setBorder(itemTitle);
    };

    return (
        <div>
            <div onClick={() => setToggleButton(false)} className="bottom-sheet2 w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999] p-3 sm:p-4">
                <div onClick={(e) => e.stopPropagation()} className="bottom-sheet-content2 gomeet-payment-modal bg-white w-full max-w-[480px] rounded-3xl p-4 sm:p-6 shadow-2xl overflow-hidden">
                    {page !== "BuyCoin" && <div className="mb-3">
                        <h6 className="font-bold text-gray-900 text-base">{t("Add Wallet Amount")}</h6>
                        <div className="flex items-center justify-between mt-2">
                            <div className="flex gap-3 w-full items-center border-2 focus-within:border-[rgba(152,14,255,1)] border-gray-200 px-3.5 py-2 rounded-xl bg-gray-50/50">
                                <img src={wallet} alt="" className="w-5 h-5" />
                                <input type="number" onChange={(e) => setInput(e.target.value)} className="outline-none w-full bg-transparent text-[rgba(152,14,255,1)] font-bold text-base" placeholder={t('Enter Amount')} />
                            </div>
                        </div>
                    </div>}
                    <div>
                        {page === "Wallet" && <h6 className="text-gray-500 text-sm font-semibold mb-3">{t("Select Payment Method")}</h6>}
                        {page === "BuyCoin" && coin > 0 && <div className="flex items-center justify-between mb-3 bg-purple-50/60 p-2.5 rounded-xl border border-purple-100">
                            <div className="flex gap-2.5 items-center">
                                <img src={wallet} alt="" className="w-5 h-5" />
                                <h6 className="m-0 text-xs sm:text-sm font-bold text-gray-800">{t("My Wallet")} (${btnDis ? (coin - Amount).toFixed(2) : coin})</h6>
                            </div>
                            <button type="button">
                                <div className="df-center gap-3">
                                    <label className="switch">
                                        <input onClick={SwitchHandler} type="checkbox" checked={btnDis} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </button>
                        </div>}
                        <div className="scroll-container2 max-h-[52vh] h-[320px] overflow-x-hidden overflow-y-auto pr-1">
                            {
                                payDetails.map((item) => {
                                    const isSelected = border === item.title;
                                    return (
                                        <div
                                            key={item.id || item.title}
                                            onClick={() => { SelectPaymentMethodHandle(item.title); setAttributes(item.attributes); }}
                                            className={`${
                                                isSelected
                                                    ? "border-[rgba(152,14,255,1)] bg-purple-50/40 shadow-xs"
                                                    : "border-gray-200 hover:border-gray-300"
                                            } mb-2.5 flex items-center justify-between gap-3 cursor-pointer border-2 rounded-2xl p-3 transition-all`}
                                        >
                                            <div className="flex items-center gap-3 min-w-0 flex-1">
                                                <img
                                                    src={imageBaseURL + item.img}
                                                    className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl object-contain border border-gray-100 bg-white p-1 shrink-0"
                                                    alt={item.title}
                                                />
                                                <div className="min-w-0 flex-1 text-left">
                                                    <h4 className="m-0 text-xs sm:text-sm font-bold text-gray-900 truncate">
                                                        {item.title}
                                                    </h4>
                                                    {item.subtitle && (
                                                        <p className="m-0 text-[11px] sm:text-xs text-gray-500 font-normal line-clamp-2 mt-0.5 leading-snug">
                                                            {item.subtitle}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                            <div
                                                className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${
                                                    isSelected
                                                        ? "border-[rgba(152,14,255,1)] bg-[rgba(152,14,255,1)]"
                                                        : "border-gray-300"
                                                }`}
                                            >
                                                {isSelected && (
                                                    <span className="w-2 h-2 rounded-full bg-white block"></span>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                    <button
                        onClick={() => PurchaseHandler(border)}
                        className="text-white bg-[rgba(152,14,255,1)] hover:bg-[rgba(130,10,225,1)] w-full font-bold text-sm sm:text-base rounded-2xl py-3 mt-3 shadow-lg transition-all active:scale-[0.98] cursor-pointer"
                    >
                        {btnDis ? t("Wallet Pay") : t("Continue")}
                    </button>
                </div>
            </div>

            {payId === "Razorpay" && button && <Razorpay Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />}
            {payId === "Paypal" && button && <div onClick={() => setPayId("")} id="BlockSection" className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <Paypal Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />
                    </div>
                </div>
            </div>}
            {payId === "Stripe" && button && <div onClick={() => setPayId("")} id="BlockSection" className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <StripePayment Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />
                    </div>
                </div>
            </div>}
            {payId === "PayStack" && button && <div onClick={() => setPayId("")} id="BlockSection" className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-30 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <PayStack Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />
                    </div>
                </div>
            </div>}
            {payId === "FlutterWave" && button && <FlutterWave Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />}
            {payId === "SenangPay" && button && <SenangPay Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />}
            {payId === "Payfast" && button && <Payfast Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />}
            {payId === "Midtrans" && button && <Midtrans Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} />}
            {payId === "2checkout" && button && <Checkout Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />}
            {payId === "Khalti Payment" && button && <KhaltiPayment Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />}
            {payId === "MercadoPago" && button && <MercadoPagoCheckout Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />}
            {payId === "Paytm" && button && <PaytmPayment Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} />}
            {payId === "Cashfree" && button && <Cashfree Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />}
            {payId === "SSLCommerz" && button && <SSLCommerz Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />}
            {payId === "Instamojo" && button && <Instamojo Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />}
            {payId === "Tap" && button && <Tap Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />}
            {payId === "PerfectMoney" && button && <PerfectMoney Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />}
            {payId === "PayDunya" && button && <PayDunya Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />}
            {payId === "Mollie" && button && <Mollie Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />}
            {payId === "bKash" && button && <BKash Amount={amount} ItemType={ItemType || (page === "BuyCoin" ? "package" : "wallet")} ItemId={ItemId || 0} Attributes={attributes} />}
        </div>
    );
};

export default Payment;
/* jshint ignore:end */
